module.exports = __webpack_public_path__ + "img/icon-simplex-logo.4fd42ff8.png";